import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Users, Calendar, Target, Lightbulb, Trophy, MapPin, Music } from 'lucide-react';
import { eventTypes } from '../mock';

const Evenements = () => {
  const servicePhases = [
    {
      icon: Lightbulb,
      title: 'Planification',
      services: [
        'Analyse des besoins',
        'Choix du pays, ville et lieux',
        'Conception de l\'événement'
      ]
    },
    {
      icon: MapPin,
      title: 'Logistique complète',
      services: [
        'Billeterie',
        'Hébergement',
        'Chauffeurs & transferts',
        'Salles de réunion ou conférence',
        'Gestion du planning détaillé'
      ]
    },
    {
      icon: Music,
      title: 'Production & Expérience',
      services: [
        'Traiteurs & restauration',
        'Décoration & scénographie',
        'Audiovisuel : son, lumière, écrans',
        'Photographie & vidéo',
        'Interprétariat & traduction',
        'Hôtes & protocoles VIP'
      ]
    }
  ];

  const advantages = [
    { icon: Globe, text: 'Forte expérience multi-pays' },
    { icon: Award, text: 'Service exclusif, non standardisé' },
    { icon: Users, text: 'Coordination sur site' },
    { icon: Target, text: 'Transparence budgétaire' },
    { icon: Clock, text: 'Disponibilité 24/7' },
    { icon: Trophy, text: 'Exécution premium' }
  ];

  return (
    <div style={{ background: 'var(--bg-page)' }}>
      {/* Hero Section with Image */}
      <section style={{
        position: 'relative',
        padding: '180px 0 100px',
        overflow: 'hidden'
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 0
        }}>
          <img
            src="https://images.unsplash.com/photo-1720700126957-769e2f2fc0fc"
            alt="Corporate Event"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              position: 'absolute'
            }}
          />
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.88), rgba(26, 28, 27, 0.75))'
          }}></div>
        </div>

        <div className="container" style={{
          maxWidth: '87.5rem',
          margin: '0 auto',
          padding: '0 40px',
          position: 'relative',
          zIndex: 1
        }}>
          <div className="caption" style={{
            color: 'var(--brand-primary)',
            marginBottom: '20px'
          }}>
            Événements Corporate Internationaux
          </div>
          <h1 className="heading-1" style={{
            color: 'var(--brand-primary)',
            marginBottom: '30px',
            maxWidth: '900px'
          }}>
            Organisation d'événements corporate internationaux
          </h1>
          <p className="body-large" style={{
            color: 'var(--text-secondary)',
            maxWidth: '700px',
            marginBottom: '40px'
          }}>
            Des événements professionnels exécutés avec excellence, en Afrique, Europe, Asie et au Moyen-Orient.
          </p>
          <Link to="/contact" className="btn-primary">
            Demander un devis <ArrowRight size={20} />
          </Link>
        </div>
      </section>

      {/* Introduction */}
      <section style={{
        padding: '100px 0',
        background: 'var(--bg-page)',
        borderTop: '1px solid var(--border-medium)'
      }}>
        <div className="container" style={{
          maxWidth: '87.5rem',
          margin: '0 auto',
          padding: '0 40px'
        }}>
          <div style={{
            maxWidth: '900px',
            margin: '0 auto'
          }}>
            <h2 className="heading-3" style={{
              color: 'var(--brand-primary)',
              marginBottom: '30px',
              textAlign: 'center'
            }}>
              Pourquoi externaliser vos événements ?
            </h2>
            <p className="body-medium" style={{
              color: 'var(--text-secondary)',
              marginBottom: '20px',
              textAlign: 'center'
            }}>
              Planifier un événement en interne détourne les entreprises de leurs priorités.
            </p>
            <p className="body-medium" style={{
              color: 'var(--text-secondary)',
              marginBottom: '20px',
              textAlign: 'center'
            }}>
              L'Agence prend en charge l'intégralité du processus pour créer des événements cohérents, fluides et parfaitement alignés avec vos objectifs.
            </p>
            <p className="body-medium" style={{
              color: 'var(--text-secondary)',
              textAlign: 'center'
            }}>
              Nous travaillons en étroite synergie avec vos équipes pour produire une expérience sur mesure, tout en vous offrant un service exclusif réservé à un nombre limité de clients.
            </p>
          </div>
        </div>
      </section>

      {/* Event Types */}
      <section style={{
        padding: '100px 0',
        background: 'var(--secondary-olive)',
        borderTop: '1px solid var(--border-medium)',
        borderBottom: '1px solid var(--border-medium)'
      }}>
        <div className="container" style={{
          maxWidth: '87.5rem',
          margin: '0 auto',
          padding: '0 40px'
        }}>
          <h2 className="heading-2" style={{
            color: 'var(--brand-primary)',
            marginBottom: '60px',
            textAlign: 'center'
          }}>
            Types d'événements
          </h2>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '30px'
          }}>
            {eventTypes.map((type, index) => (
              <div key={index} style={{
                background: 'var(--bg-card)',
                padding: '30px',
                border: '1px solid var(--border-medium)',
                textAlign: 'center',
                transition: 'transform 0.3s ease, background-color 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.backgroundColor = 'var(--bg-page)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.backgroundColor = 'var(--bg-card)';
              }}>
                <Calendar size={32} color="var(--brand-primary)" style={{ marginBottom: '15px' }} />
                <div className="heading-4" style={{
                  color: 'var(--brand-primary)',
                  fontSize: '1rem'
                }}>
                  {type}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Included */}
      <section style={{
        padding: '100px 0',
        background: 'var(--bg-page)'
      }}>
        <div className="container" style={{
          maxWidth: '87.5rem',
          margin: '0 auto',
          padding: '0 40px'
        }}>
          <h2 className="heading-2" style={{
            color: 'var(--brand-primary)',
            marginBottom: '60px',
            textAlign: 'center'
          }}>
            Services inclus
          </h2>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
            gap: '40px'
          }}>
            {servicePhases.map((phase, index) => {
              const Icon = phase.icon;
              return (
                <div key={index} style={{
                  background: 'var(--bg-card)',
                  padding: '40px',
                  border: '1px solid var(--border-medium)',
                  transition: 'transform 0.3s ease'
                }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-4px)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
                  <div style={{
                    width: '60px',
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '2px solid var(--brand-primary)',
                    borderRadius: '50%',
                    marginBottom: '20px'
                  }}>
                    <Icon size={28} color="var(--brand-primary)" />
                  </div>
                  <h3 className="heading-4" style={{
                    color: 'var(--brand-primary)',
                    marginBottom: '20px',
                    textTransform: 'uppercase',
                    fontSize: '1rem'
                  }}>
                    {phase.title}
                  </h3>
                  <ul style={{
                    listStyle: 'none',
                    padding: 0
                  }}>
                    {phase.services.map((service, idx) => (
                      <li key={idx} style={{
                        marginBottom: '10px',
                        paddingLeft: '20px',
                        position: 'relative',
                        color: 'var(--text-secondary)',
                        fontSize: '0.95rem'
                      }}>
                        <span style={{
                          position: 'absolute',
                          left: 0,
                          color: 'var(--brand-primary)'
                        }}>•</span>
                        {service}
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Why Choose L'Agence */}
      <section style={{
        padding: '100px 0',
        background: 'var(--bg-card)',
        borderTop: '1px solid var(--border-medium)',
        borderBottom: '1px solid var(--border-medium)'
      }}>
        <div className="container" style={{
          maxWidth: '87.5rem',
          margin: '0 auto',
          padding: '0 40px'
        }}>
          <h2 className="heading-2" style={{
            color: 'var(--brand-primary)',
            marginBottom: '60px',
            textAlign: 'center'
          }}>
            Pourquoi L'Agence ?
          </h2>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '40px'
          }}>
            {advantages.map((advantage, index) => {
              const Icon = advantage.icon;
              return (
                <div key={index} style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center',
                  padding: '20px'
                }}>
                  <div style={{
                    width: '70px',
                    height: '70px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '2px solid var(--brand-primary)',
                    borderRadius: '50%',
                    marginBottom: '20px'
                  }}>
                    <Icon size={32} color="var(--brand-primary)" />
                  </div>
                  <div className="heading-4" style={{
                    color: 'var(--brand-primary)',
                    fontSize: '1rem'
                  }}>
                    {advantage.text}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{
        padding: '120px 0',
        background: 'var(--bg-page)'
      }}>
        <div className="container" style={{
          maxWidth: '87.5rem',
          margin: '0 auto',
          padding: '0 40px',
          textAlign: 'center'
        }}>
          <h2 className="heading-2" style={{
            color: 'var(--brand-primary)',
            marginBottom: '30px'
          }}>
            Créons ensemble votre prochain événement
          </h2>
          <p className="body-large" style={{
            color: 'var(--text-secondary)',
            marginBottom: '40px',
            maxWidth: '600px',
            margin: '0 auto 40px'
          }}>
            Que ce soit un séminaire, une conférence ou un team building international, nous transformons votre vision en réalité.
          </p>
          <div style={{
            display: 'flex',
            gap: '20px',
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            <Link to="/contact" className="btn-primary">
              Demander un devis <ArrowRight size={20} />
            </Link>
            <a href="tel:+243841223949" className="btn-secondary">
              Appeler maintenant
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

const Globe = ({ size, color, style }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={style}>
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="2" y1="12" x2="22" y2="12"></line>
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
  </svg>
);

const Award = ({ size, color, style }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={style}>
    <circle cx="12" cy="8" r="7"></circle>
    <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>
  </svg>
);

const Clock = ({ size, color, style }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={style}>
    <circle cx="12" cy="12" r="10"></circle>
    <polyline points="12 6 12 12 16 14"></polyline>
  </svg>
);

export default Evenements;